// Common
import { ReactElement } from 'react'

// Styles
import { makeStyles } from '@material-ui/styles'
import COLORS from 'lib/colors'

// Icons
import { SvgIcon } from '@material-ui/core'

type Ids = {
	done: string;
}

const useStyle = makeStyles({
	root: {
		'& circle': {
			transition: 'fill .2s ease',
		},
		'&:active circle': {
			fill: COLORS.primary,
		},
	},
})

function PointIcon(props: Ids): ReactElement {
	const { done } = props

	const classes = useStyle()
	return (
		<SvgIcon className={classes.root} viewBox="0 0 10 10" style={{width: 10, height: 10, margin: 10}}>
			<circle cx="5" cy="5" r="4.5" fill="#73C21E"/>
			{done === 'done' ? <circle cx="5" cy="5" r="4.5" fill="#73C21E"/> : <circle cx="5" cy="5" r="4" fill="white"/> }
		</SvgIcon>
	)
}

export default PointIcon
